 


class VariantSelector extends HTMLElement {
    constructor() {
        super();
   
      
        this.url = this.dataset.url ? this.dataset.url  : "mitopets-pad"
        this.FeaturedPrice = this.querySelector('.price-item2')
        this.CurrentPrice = document.querySelector('.price-item')
        this.productId = document.querySelector('.product-variant-id')
        this.pet_product_id = document.querySelector('.product-variant-id-2')
     this.data ;
        this.currency = this.CurrentPrice.innerText.match(/^([^\d]+)?([\d.,]+)/);
          this.buyButton = document.querySelector('.product-form__buttons > button')
    }

    connectedCallback() {

        this.rawdata = this.querySelector('script')?.innerText
        this.parent = this.querySelector('.grp-insert')

       
        if (this.rawdata !== undefined) {
      
           this.data = JSON.parse(this.rawdata);
       
          const { meta } = this.data;
            if (Object.keys(this.data).length > 0) this.GroupedMetaData(meta)
        }

        this.options = this.querySelectorAll('button');

        if (this.options.length > 1) {
            this.onloadCheck()
            this.addListeners();
        } else {
            this.getVariantImages()
        }
    }

    addListeners() {

        this.options.forEach(option => {
            option.addEventListener('click', () => {
  
                !option.classList.contains('pets_var') && window.history.replaceState({}, '', `${this.url}?variant=${option.dataset.variantId}`);
                this.clearSelection()
                option.classList.add('is-selected');
                if (option.classList.contains('pets_var')) {
                    this.FeaturedPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
                    this.pet_product_id.value = option.dataset.variantId
                } else {
                
                    this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
                    this.productId.value = option.dataset.variantId
                     const filterVariant = this.data.variants.filter((variant)=> variant.id === Number(this.productId.value) )
                    console.log(filterVariant)
                
                  if(filterVariant['0'].available ){
              
                      this.buyButton.disabled = false;
                    this.buyButton.textContent = "+ Add to Cart"
               
                
                  }else{
                    
                    this.buyButton.disabled = true;
                    this.buyButton.textContent = "Sold Out"
                       
                  }
               
             
                }

               option.dataset.variantAlt && this.getVariantImages(option.dataset?.variantAlt.trim())
            });
        });
    }

    clearSelection() {

        this.options.forEach(option => {
            option.classList.remove('is-selected');
        });
    }

    onloadCheck() {
        this.options.forEach(option => {
            if (option.classList.contains('is-selected') && option.dataset.variantAlt && option.dataset.variantId) {

                window.history.replaceState({}, '', `${this.url}?variant=${option.dataset.variantId}`);
               this.getVariantImages(option.dataset?.variantAlt.trim())
               this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
            }
            else if (option.classList.contains('is-selected')) {
                if (option.classList.contains('pets_var')) {
                    this.FeaturedPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
                    this.pet_product_id.value = option.dataset.variantId
                } else {
                    this.CurrentPrice.innerText = this.formatPrice(option.getAttribute('data-price'))
                    this.productId.value = option.dataset.variantId
                    this.getVariantImages()
                    option.dataset.variantAlt && this.getVariantImages(option.dataset?.variantAlt.trim())
                }

            }
        });

    }

    getVariantImages(variant) {
        const title = document.querySelector('.product-title').textContent
        let images = document.querySelectorAll('.product__gallery__main__media')
        if (variant !== undefined) {
            images.forEach((image,index) => {
                let str = image.dataset.alt.trim()
                if (str === variant || str === title) {

                       image.classList.remove('hidden');
                        document.getElementById(`${image.dataset.mediaId}`).style.display="block"
                   } else {

                       image.classList.add('hidden');
                       document.getElementById(`${image.dataset.mediaId}`).style.display="none"
                 }
               });

               // Mark all activeimages with a index number
               let activeImages = [...images]?.filter((image) => image.classList.contains('hidden') == false);
               activeImages.forEach((image, index) => {
                 image.dataset.index = index;
               });
        }
        else {
            images.forEach((image) => {
                  image.classList.remove('hidden');
                document.getElementById(`${image.dataset.mediaId}`).style.display="block"
               });

        }
    }

    GroupedMetaData(meta) {
        let groupedMeta = meta.reduce((acc, item , index , arr) => {
            // Use the option_group value as the key
            let key = item.option_group;

            // If an array already present for key, push it to the array. Else, create an array and push it
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(item);

            // Return the modified object
            return acc;
        }, {});

       
        if (Object.keys(groupedMeta).length > 1) {
            this.PrintTitle(groupedMeta)
        } else if (meta.length > 1){
            const parentElement = $(this.querySelector('.display-flex'));
                const $parentGroup  = $(`<div > </div>`)
             const $Group = $(
                `   <div class="buttons-group">
                 </div>
                ` )
                parentElement.append($parentGroup)

            meta.forEach((ele,index) => {
                document.querySelector('.price-item');
                if (index === 0 && parentElement.find('.is-selected').length === 0) {
                    $Group.append(`
                        <button class="is-selected " data-price=${ele.price} data-variant-id=${ele.variant_id}
                         data-variant-alt="${ele.featured_image}">${ele.title}</button>
                    `);
                }
                else {
                    $Group.append(`
                    <button data-price=${ele.price} data-variant-id=${ele.variant_id} data-variant-alt="${ele.featured_image}">${ele.title}</button>
                `);
                }


            });
            $parentGroup.append($Group)
        }

    }

    PrintTitle(groupedData) {
        const parentElement = $(this.querySelector('.display-flex')); // Cache the parent element

        for (const property in groupedData) {
            const content = property === "null" ? " " : property;
            const $parentGroup = $(
                `   <div >
                <p class="buy-buttons-group">${content}</p>
                 </div>
                ` )

            const $Group = $(
                `   <div class="buttons-group ">
                 </div>
                ` )

            parentElement.append($parentGroup);


            groupedData[property].forEach((item, index) => {
                document.querySelector('.price-item')
           
                if (index === 0 && parentElement.find('.is-selected').length === 0) {
                  
                    $Group.append(`
                    <div class="variant-btn" >
                        <button class="is-selected " data-price=${item.price}  data-variant-id="${item.variant_id}"
                       data-variant-alt="${item.featured_image}" >${item.title}</button>
  <div/>
                    `);
                }
                else {
                    $Group.append(`
                    <div class="variant-btn" >
                    <button data-price=${item.price} data-variant-id="${item.variant_id}" data-variant-alt="${item.featured_image}" >${item.title}</button>
                    <div/>
                    `);
                }
            });

            $parentGroup.append($Group)
            }

    }


 formatPrice(priceInCents) {
       
        const dollars = priceInCents / 100;

  
        return `${this.currency[1]} ${dollars.toLocaleString("en-US")}`;
      }


};


customElements.define('custom-variant-selector', VariantSelector);
